import { CategoryMegaMenuSubCategory } from '@/types/categoryMegaMenu';

export const distributeCategoryMegaMenuColumns = (
    subCategories: CategoryMegaMenuSubCategory[],
    columnCount: number
): CategoryMegaMenuSubCategory[][] => {
    const columns = Array.from({ length: columnCount }, () => [] as CategoryMegaMenuSubCategory[]);
    const columnHeights = Array.from({ length: columnCount }, () => 0);

    subCategories.forEach((subCategory) => {
        const shortestColumnIndex = columnHeights.indexOf(Math.min(...columnHeights));

        columns[shortestColumnIndex].push(subCategory);
        columnHeights[shortestColumnIndex] += 1 + subCategory.children.length;
    });

    return columns;
};
